import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { RepairAppointmentComponent } from '../repair-appointment/repair-appointment.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-repair-appointment-list',
  templateUrl: './repair-appointment-list.component.html',
  styleUrls: ['./repair-appointment-list.component.css']
})
export class RepairAppointmentListComponent implements OnInit {

  public menu_item_id = '79';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['customer_no', 'customer_name', 'customer_name_en', 'car_type', 'appointment_date', 
    'appointment_time', 'edit', 'del'];
  displayedColumns2 = ['customer_no', 'customer_name', 'customer_name_en', 'car_type', 'appointment_date', 
    'appointment_time'];

  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<RepairAppointmentComponent>;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'appointment', 'customer_name': '', 'customer_no': '', 'from_date': new Date(),
    'to_date': new Date(), 'title': ''
  };

  Success_Msg;
  Error_Msg;
  Appoint_List;
  Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {
    //this.compName = this.utils.getParamValue('company_name_' + this.applicationConstants.user_lang);

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Appoint_List').subscribe((res: string) => {
      this.Appoint_List = res;
    });
    this.model['title'] = this.Appoint_List;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

  }

  search() {

    let condition = "";
    if (this.model['from_date'] != undefined) {
      let from_date = this.model['from_date'].getFullYear() + "-" + (this.model['from_date'].getMonth() + 1) + "-" +
        this.model['from_date'].getDate() + ' 00:00:00';
      condition += " AND `appointment`.`appointment_date` >= '" + from_date + "'";
    }

    if (this.model['to_date'] != undefined) {
      let to_date = this.model['to_date'].getFullYear() + "-" + (this.model['to_date'].getMonth() + 1) + "-" +
        this.model['to_date'].getDate() + ' 23:59:59';
      condition += " AND `appointment`.`appointment_date` <= '" + to_date + "'";
    }

    if (this.model['customer_name'] != '')
      condition += " AND (`customer`.`customer_name` LIKE '%" + this.model['customer_name'] +
        "%' OR `customer`.`customer_name_en` LIKE '%" + this.model['customer_name'] + "%')";

    if (this.model['customer_no'] != '')
      condition += " AND `customer`.`customer_no` LIKE '%" + this.model['customer_no'] + "%'";

    let query = "SELECT `appointment`.*, `customer`.`customer_name`, `customer`.`customer_name_en`," +
      " `customer`.`customer_no`, `customer`.`car_type` FROM `appointment`, `customer` WHERE" +
      " `appointment`.`customer_no` = `customer`.`customer_no` AND `appointment`.`status` = '1'" + condition;
    console.log(query);
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dp.forEach(element => {
          element.appointment_time = (element.appointment_date).substring(11, 13) + ':' + (element.appointment_date).substring(14, 16);
          element.appointment_date = (element.appointment_date).substring(0, 10);
        });
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  new_appointment() {
    this.addDialogRef = this.dialog.open(RepairAppointmentComponent, {
      hasBackdrop: false,
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  edit_appointment(row) {
    let dialog_data = {
      'table_name': 'appointment', 'appointment_id': row.appointment_id,
      'appointment_date': row.appointment_date + ' ' + row.appointment_time + ':00',
      //'appointment_time': row.appointment_time,
      'customer_no': row.customer_no,
      'comment': row.comment
    };

    this.addDialogRef = this.dialog.open(RepairAppointmentComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  del_appointment(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'appointment_id': row.appointment_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%">' + this.Appoint_List + '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('appointment_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
